import { Component } from "@angular/core";

@Component({
  selector: 'highlights-widget',
  standalone: true,
  template: `
    <section class="py-12 px-6 md:px-12 lg:px-20 bg-surface-50">
      <h2 class="text-3xl font-bold mb-8">
        What Most Automation Tools Cannot Do
      </h2>

      <div class="grid md:grid-cols-2 gap-6">
        <div>
          <h3>Broadcast → Collect → Resume</h3>
          <p>
            Send leads to vendors, collect replies asynchronously,
            aggregate results, and respond back to users automatically.
          </p>
        </div>

        <div>
          <h3>One Engine, Multiple Channels</h3>
          <p>
            Run the same workflows on WhatsApp today
            and Voice tomorrow without rebuilding logic.
          </p>
        </div>

        <div>
          <h3>External Orchestration via n8n</h3>
          <p>
            Offload integrations, retries, and waits to n8n
            while your workflow engine stays deterministic.
          </p>
        </div>

        <div>
          <h3>Enterprise Safety</h3>
          <p>
            No AI-driven flow decisions. Full audit trail.
            Predictable behavior under load.
          </p>
        </div>
      </div>
    </section>
  `
})
export class HighlightsWidget {}
